import { NeutralButton } from "../../../common/Buttons"
import HighlightMatch from "../../../../utilities/HighlightMatch"
import { useNavigate } from "react-router-dom"
import useStore from "../../../../store"
import { FaCheck, FaRegClock, FaExclamationTriangle } from "react-icons/fa"
import { AccordionItemContent, AccordionItemTrigger, AccordionItem } from "../../../ui/accordion"
import { DateTime } from "luxon"
import InfoItem from "../../../common/InfoItem"
import AuditUnitWarnings from "../../AuditUnit/AuditUnitWarnings"
import { getAuditUnitWarnings } from "../../../../utilities/auditUtilities"

export default function FieldAuditUnitRow({ fieldAuditUnit, filter, handleClick = () => {}, fieldAuditId }) {
  const navigate = useNavigate()
  const setAuditUnit = useStore((state) => state.setAuditUnit)

  const warnings = getAuditUnitWarnings(fieldAuditUnit)

  const handleAuditUnitClick = () => {
    setAuditUnit(fieldAuditUnit)
    navigate(`/field_audits/${fieldAuditId}/audit_units/${fieldAuditUnit.id}`)
  }

  const icon = () => {
    if (fieldAuditUnit.attributes['is-audited']) {
      return <FaCheck color='green' />
    } else if (warnings.length > 0) {
      return <FaExclamationTriangle className='text-fpx-red' />
    } else {
      return <FaRegClock color='yellow' />
    }
  }

  return (
    <AccordionItem
      value={fieldAuditUnit.id}
      className='border-b-2 border-grey-700'
    >
      <div
        className='flex w-full items-center
          p-2 text-grey-300 text-left lg:hover:bg-grey-700 lg:hover:cursor-pointer'
        onClick={() => handleClick(fieldAuditUnit.id)}
      >
          <div className="flex flex-row w-1/2 md:w-2/3">
            <div className="flex flex-col items-center justify-center text-xl w-9 pr-2">
              {icon()}
              <AccordionItemTrigger display='flex' flexDirection='column' alignItems='center' justifyContent='center' />
            </div>
            <div className="flex flex-col w-full">
              <div className={`text-sm text-grey-300`}>
                <HighlightMatch str={`${fieldAuditUnit.attributes.year} ${fieldAuditUnit.attributes.make}`} match={filter} truncate={true}/>
              </div>
              <div className={`text-lg text-grey-100`}>
                <HighlightMatch str={fieldAuditUnit.attributes.model} match={filter} truncate={true}/>
              </div>
              <div className='text-xs'>
                <HighlightMatch str={fieldAuditUnit.attributes.vin} match={filter} truncate={true}/>
              </div>
            </div>
          </div>

          <div className="flex justify-end w-1/2 md:w-1/3">
            <NeutralButton
              text={fieldAuditUnit.attributes['is-audited'] ? "Edit Audit" : "Audit Unit"}
              onClick={handleAuditUnitClick}
            />
          </div>
      </div>
      <AccordionItemContent>
        <AuditUnitWarnings warnings={warnings} />
        <div className="grid grid-cols-3 text-sm pl-2">
          <InfoItem title="Color" data={fieldAuditUnit.attributes.color} />
          <InfoItem title="Refloors" data={fieldAuditUnit.attributes['current-floor'] - 1} />
          <InfoItem title="Days Floored" data={fieldAuditUnit.attributes['days-floored']} />
          <InfoItem title="Due On" data={DateTime.fromISO(fieldAuditUnit.attributes['due-on']).toLocaleString()} />
        </div>
      </AccordionItemContent>
    </AccordionItem>
  )
}